import React from 'react';
import { css } from '@emotion/core';
import Typography from '@material-ui/core/Typography';

import { system500 } from 'Mui/styles/color';

export default function PageForbidden() {
    return (
        <div css={style}>
            <Typography variant="h1">403 Forbidden</Typography>
        </div>
    );
}

const style = css`
    color: ${system500.color};
    height: 100%;
    text-align: center;
    > * {
        position: relative;
        top: 50%;
        transform: translateY(-50%);
    }
`;
